export const reportsContext = require.context(".", true, /\_controller.js$/)
